import React, { memo, useState, useEffect } from "react";

// Libraries
import { Col, Container, Tab, Tabs, Row } from "react-bootstrap";
import { PropTypes } from "prop-types";
import { m } from "framer-motion";

// Components
import Buttons from "../Button/Buttons";

// Data
import { TabData01 } from "./TabData";
import { Link } from "react-router-dom";

//Scss
import "../../Assets/scss/default.scss";
const Tab01 = (props) => {
  const [activeKey, setActiveKey] = useState(
    props.activeKey || props.data[0].id
  );
  useEffect(() => {
    // Update activeKey whenever props.activeKey or props.data changes
    setActiveKey(props.activeKey);
  }, [props.activeKey]);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Tabs
      activeKey={activeKey}
      onSelect={(k) => setActiveKey(k)}
      className="tab-style-01 font-serif mb-[7.4rem] flex bg-transparent border-b-0 font-medium text-center justify-center md:mb-[60px] sm:mb-[20px] md:flex-col"
    >
      {props?.data?.map((item, i) => {
        return (
          <Tab
            className="tab-style-01 "
            key={item.id}
            eventKey={item.id}
            title={item.tabTitle ? item.tabTitle : "Tab Title"}
          >
            {item.components?.map((component, index) => (
              <m.div
                className="row items-center mb-[40px] bg-grey-50"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.9 }}
                key={index}
                id={index}
              >
                {isSmallScreen ? (
                  <>
                    <Col
                      lg={{ offset: 1, span: 5 }}
                      md={7}
                      className="md:px-[15px] sm:px-[15px] sm:text-start xs:text-center"
                    >
                      {component.title && (
                        <h5 className="font-serif font-semibold text-darkgray tracking-[-0.5px] mb-[35px] sm:mb-[30px] default-font-family-bold">
                          {component.title}
                        </h5>
                      )}
                    </Col>
                    <Col md={6} className="sm:mb-[40px]">
                      {component.img && (
                        <img
                          height="434"
                          width="555"
                          className="w-full"
                          src={component.img}
                          alt="tab"
                        />
                      )}
                    </Col>
                    <Col
                      lg={{ offset: 1, span: 5 }}
                      md={7}
                      className="md:px-[15px] sm:px-[15px] sm:text-start xs:text-center"
                    >
                      {component.subtitle && (
                        <span
                          className="text-gradient  mb-[15px] font-serif text-md font-medium uppercase inline-block leading-[20px] default-font-family"
                          style={{
                            backgroundImage:
                              "linear-gradient(to right,#71bdea 0,#775ea5 100%)",
                          }}
                        >
                          {component.subtitle}
                        </span>
                      )}

                      {component.content && (
                        <p
                          className="text-justify mb-[45px] w-[85%] md:w-full xs:mb-[15px] default-font-family"
                          dangerouslySetInnerHTML={{
                            __html: component.content.replace(/\n/g, "<br />"),
                          }}
                        />
                      )}
                      {component.buttonLink && component.buttonTitle && (
                        <Link
                          aria-label="tab button"
                          className="btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy md:mb-[15px] xs:mb-0 xs:mt-[20px] default-font-family"
                          size="md"
                          themecolor="#232323"
                          color="#ffffff"
                          to={component.buttonLink}
                          target="_blank"
                          title={component.buttonTitle}
                        >
                          {component.buttonTitle}
                        </Link>
                      )}
                      {component.buttonLink1 && component.buttonTitle1 && (
                        <Link
                          aria-label="tab button"
                          className="ml-4 btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy md:mb-[15px] xs:mb-0 xs:mt-[20px] default-font-family"
                          size="md"
                          themecolor="#232323"
                          color="#ffffff"
                          to={component.buttonLink1}
                          target="_blank"
                          title={component.buttonTitle1}
                        >
                          {component.buttonTitle1}
                        </Link>
                      )}
                    </Col>
                  </>
                ) : index % 2 === 0 ? (
                  <>
                    <Col md={6} className="sm:mb-[40px]">
                      {component.img && (
                        <img
                          height="434"
                          width="555"
                          className="w-full"
                          src={component.img}
                          alt="tab"
                        />
                      )}
                    </Col>
                    <Col
                      lg={{ offset: 1, span: 5 }}
                      md={7}
                      className="md:px-[15px] sm:px-[15px] sm:text-start xs:text-center default-font-family"
                    >
                      {component.subtitle && (
                        <span
                          className="text-gradient  mb-[15px] font-serif text-md font-medium uppercase inline-block leading-[20px] default-font-family"
                          style={{
                            backgroundImage:
                              "linear-gradient(to right,#71bdea 0,#775ea5 100%)",
                          }}
                        >
                          {component.subtitle}
                        </span>
                      )}
                      {component.title && (
                        <h5 className="font-serif font-semibold text-darkgray tracking-[-0.5px] mb-[35px] sm:mb-[30px] default-font-family-bold">
                          {component.title}
                        </h5>
                      )}
                      {component.content && (
                        <p
                          className="text-justify mb-[45px] w-[85%] md:w-full xs:mb-[15px] default-font-family"
                          dangerouslySetInnerHTML={{
                            __html: component.content.replace(/\n/g, "<br />"),
                          }}
                        />
                      )}
                      {component.buttonLink && component.buttonTitle && (
                        <Link
                          aria-label="tab button"
                          className="btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy md:mb-[15px] xs:mb-0 xs:mt-[20px] default-font-family"
                          size="md"
                          themecolor="#232323"
                          color="#ffffff"
                          to={component.buttonLink}
                          target="_blank"
                          title={component.buttonTitle}
                        >
                          {component.buttonTitle}
                        </Link>
                      )}
                      {component.buttonLink1 && component.buttonTitle1 && (
                        <Link
                          aria-label="tab button"
                          className="ml-4 btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy md:mb-[15px] xs:mb-0 xs:mt-[20px] default-font-family"
                          size="md"
                          themecolor="#232323"
                          color="#ffffff"
                          to={component.buttonLink1}
                          target="_blank"
                          title={component.buttonTitle1}
                        >
                          {component.buttonTitle1}
                        </Link>
                      )}
                    </Col>
                  </>
                ) : (
                  <>
                    <Col
                      lg={{ offset: 1, span: 5 }}
                      md={7}
                      className="md:px-[15px] sm:px-[15px] sm:text-start xs:text-center"
                    >
                      {component.subtitle && (
                        <span
                          className="text-gradient  mb-[15px] font-serif text-md font-medium uppercase inline-block leading-[20px] default-font-family"
                          style={{
                            backgroundImage:
                              "linear-gradient(to right,#71bdea 0,#775ea5 100%)",
                          }}
                        >
                          {component.subtitle}
                        </span>
                      )}
                      {component.title && (
                        <h5 className="font-serif font-semibold text-darkgray tracking-[-0.5px] mb-[35px] sm:mb-[30px] default-font-family-bold">
                          {component.title}
                        </h5>
                      )}
                      {component.content && (
                        <p
                          className="text-justify mb-[45px] w-[85%] md:w-full xs:mb-[15px] default-font-family"
                          dangerouslySetInnerHTML={{
                            __html: component.content.replace(/\n/g, "<br />"),
                          }}
                        />
                      )}
                      {component.buttonLink && component.buttonTitle && (
                        <Link
                          aria-label="tab button"
                          className="btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy md:mb-[15px] xs:mb-0 xs:mt-[20px] default-font-family"
                          size="md"
                          themecolor="#232323"
                          color="#ffffff"
                          to={component.buttonLink}
                          target="_blank"
                          title={component.buttonTitle}
                        >
                          {component.buttonTitle}
                        </Link>
                      )}
                      {component.buttonLink1 && component.buttonTitle1 && (
                        <Link
                          aria-label="tab button"
                          className="ml-4 btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy md:mb-[15px] xs:mb-0 xs:mt-[20px] default-font-family"
                          size="md"
                          themecolor="#232323"
                          color="#ffffff"
                          to={component.buttonLink1}
                          target="_blank"
                          title={component.buttonTitle1}
                        >
                          {component.buttonTitle1}
                        </Link>
                      )}
                    </Col>
                    <Col md={6} className="sm:mb-[40px]">
                      {component.img && (
                        <img
                          height="434"
                          width="555"
                          className="w-full"
                          src={component.img}
                          alt="tab"
                        />
                      )}
                    </Col>
                  </>
                )}
              </m.div>
            ))}
          </Tab>
        );
      })}
    </Tabs>
  );
};

Tab01.defaultProps = {
  data: TabData01,
  activeKey: TabData01[0].id,
};

Tab01.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.exact({
      tabTitle: PropTypes.string,
      subtitle: PropTypes.string,
      title: PropTypes.string,
      img: PropTypes.string,
      content: PropTypes.string,
      buttonLink: PropTypes.string,
      buttonTitle: PropTypes.string,
      tabicons: PropTypes.string,
      link: PropTypes.string,
      id: PropTypes.string,
      components: PropTypes.arrayOf(
        PropTypes.shape({
          img: PropTypes.string,
          title: PropTypes.string,
          subtitle: PropTypes.string,
          content: PropTypes.string,
          buttonLink: PropTypes.string,
          buttonTitle: PropTypes.string,
          buttonLink1: PropTypes.string,
          buttonTitle1: PropTypes.string,
        })
      ),
    })
  ),
  activeKey: PropTypes.string,
};

export default memo(Tab01);
